const size = {
  desktopMaxWidth: '90rem',
  desktopMedWidth: '80rem',
  desktopWidth: '64.8125rem',
  desktopMinWidth: '62rem',
  tabletMaxWidth: '49.375rem',
  tabletMinWidth: '41.875rem',
  mobileMaxWidth: '33.75rem',
  mobileMinWidth: '30rem',
};

export const media = {
  desktopMax: `(min-width: ${size.desktopMaxWidth})`,
  desktopMed: `(min-width: ${size.desktopMedWidth})`,
  desktop: `(min-width: ${size.desktopWidth})`,
  desktopMin: `(min-width: ${size.desktopMinWidth})`,
  tabletMax: `(min-width: ${size.tabletMaxWidth})`,
  tabletMin: `(min-width: ${size.tabletMinWidth})`,
  mobileMax: `(min-width: ${size.mobileMaxWidth})`,
  mobileMin: `(min-width: ${size.mobileMinWidth})`,
};
